import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';

export const RichTextEditor = ({ label, value, onChange, disabled, placeholder, minHeight = "120px" }) => {
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline']
    ]
  };

  return (
    <div className="flex flex-col gap-1.5 w-full">
      {label && (
        <label className="text-[10px] font-semibold text-slate-500 tracking-wider uppercase">
          {label}
        </label>
      )}
      <div className={`rich-text-container ${disabled ? 'opacity-60' : ''}`}>
        <ReactQuill 
          theme="bubble" 
          value={value || ''} 
          onChange={onChange} 
          modules={modules}
          placeholder={placeholder}
          readOnly={disabled}
        />
      </div>
      <style>{`
        .rich-text-container .ql-container {
          font-family: inherit;
          font-size: 13px;
          height: ${minHeight};
          overflow-y: auto;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          background: #ffffff;
        }
        .rich-text-container .ql-editor {
          min-height: 100%;
        }
      `}</style>
    </div>
  );
};
